export const apiUrl = process.env.API_URI;
//export const apiUrl = "http://45.33.109.25:8000/graphql/";
export const serviceWorkerTimeout =
  parseInt(process.env.SERVICE_WORKER_TIMEOUT, 10) || 60 * 1000;

export const development = process.env.NODE_ENV === "development";
export const deadlineEnv = process.env.DEADLINE;
